import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'

import ModalCreateUpdate from 'pages/partner/users/ModalCreateUpdate'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { formatDate, formatMoney, returnSign } from 'helpers/helpers'
import { httpOk, GET, POST, PUT } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [selectedItem, setSelectedItem] = useState({ 'login': '', 'phone': '', 'password': '' })
	const [modalCreateUpdate, setModalCreateUpdate] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const {
		filterData,
		setFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		applySearch,
		applyFilters,
		paginate,
		resetToInitialFilters,
	} = useFilterSearchPagination({
		initialFilterData: {},
		initialPagination: {
			url: '/partner/users',
			response: null,
		},
	})

	async function searchWithFilter(passedData = {}) {
		var filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		var filterUrl = "/partner/users"
		var urlParams = ""
		checkFilter(filterDataCopy)

		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/partner/users${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	async function createUpdate(e) {
		e.preventDefault();
		var selectedItemCopy = { ...selectedItem }

		var response
		if (!selectedItemCopy.id) {
			response = await POST('/partner/users', selectedItemCopy)
		} else {
			response = await PUT('/partner/users', selectedItemCopy)
		}

		if (httpOk(response)) {
			toggleModalCreateUpdate()
			searchWithFilter()
		}
	}

	function toggleModalCreateUpdate(bool = false, item = { 'phone': '998' }) {
		setSelectedItem(item)
		setModalCreateUpdate(bool)
	}

	function resetFilter() {
		resetToInitialFilters((nextFilterData) => {
			const resetFilterData = {
				...nextFilterData,
				search: '',
				page: null,
			}
			setFilterData(resetFilterData)
			searchWithFilter({ filterData: resetFilterData })
		})
	}

	function checkFilter(currentFilterData) {
		if (
			currentFilterData.status === null &&
			currentFilterData.page === null &&
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('users')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex flex-wrap gap-2 mb-3">
						<div>
							<FilterSearch
								value={filterData.search}
								onSearchChange={(search) => applySearch(search, (nextFilterData) => {
									searchWithFilter({ filterData: nextFilterData })
								})}>
							</FilterSearch>
						</div>
						<div>
							<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
									{t('filter')}
								</Dropdown.Toggle>
								<Dropdown.Menu className="dropdown-filter">
									<div className="row mt-3">
										<div className="col-md-12">
											<div className="d-flex justify-content-end gap-2">
												<button className="btn btn-secondary"
													onClick={() => setDropdownIsOpen(false)}>
													{t('cancel')}
												</button>
												<button className="btn btn-primary"
													onClick={() => applyFilters((nextFilterData) => {
														searchWithFilter({ filterData: nextFilterData })
													})}>
													{t('apply')}
												</button>
											</div>
										</div>
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('login')}</th>
									<th style={{ 'width': '20%' }}>{t('name')}</th>
									<th style={{ 'minWidth': '120px' }} className="text-center">{t('phone')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('bonus')}%</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('partner')}%</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('active')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('disconnected')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('deleted')}</th>
									<th style={{ 'minWidth': '120px' }} className="text-center">{t('date')}</th>
									<th style={{ 'minWidth': '33px' }} className="text-end"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">{item.login}</td>
										<td className="td-ellipsis">{item.name}</td>
										<td className="text-center">{item.phone}</td>
										<td className="text-end">{item.parent_percentage}</td>
										<td className="text-end">{item.percentage}</td>
										<td className="text-end">{formatMoney(item.count_pos_active)}</td>
										<td className="text-end">{formatMoney(item.count_pos_unpaid)}</td>
										<td className="text-end">{formatMoney(item.count_pos_deleted)}</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModalCreateUpdate(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data?.status?.total_active)}</b></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data?.status?.total_not_active)}</b></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data?.status?.total_deleted)}</b></td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={(page) => {
								paginate(page)
								searchWithFilter({ filterData: { ...filterData, page } })
							}}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL CREATE UPDATE*/}
			{modalCreateUpdate &&
				<ModalCreateUpdate
					searchWithFilter={searchWithFilter}
					selectedItem={selectedItem}
					setSelectedItem={setSelectedItem}
					createUpdate={createUpdate}
					modalCreateUpdate={modalCreateUpdate}
					toggleModalCreateUpdate={toggleModalCreateUpdate}
				>
				</ModalCreateUpdate>
			}
			{/* MODAL CREATE UPDATE*/}
		</>
	)
}

export default Index